import React, { useState, useEffect } from "react";
import { Grid, TextField, Button, Container } from "@mui/material";
import { useSelector } from "react-redux";
import Header from "components/Header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getCurrentDateYYYYMMDD } from "utils/dateUtils";
import api from "services/api";

const getInitialFormData = () => ({
  selectedDate: getCurrentDateYYYYMMDD(),
  achatGazoil: 0,
  transport: 0,
  verification: 0,
  reparation: 0,
  materielsElectriques: 0,
  fraisTransfert: 0,
  taxes: 0,
  formation: 0,
  achatElectricite: 0,
  carnetFacture: 0,
  salaires: 0,
  indemnites: 0,
  depannageRxInst: 0,
  depensesAlimentation: 0,
  depensesNettoiements: 0,
  divers: 0,
  total: 0,
  observations: "Rien à signaler",
});

const SortieCaisse = () => {
  const mode = useSelector((state) => state.global.mode);

  const [formData, setFormData] = useState(getInitialFormData());

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      total:
        prevData.achatGazoil +
        prevData.transport +
        prevData.verification +
        prevData.reparation +
        prevData.materielsElectriques +
        prevData.fraisTransfert +
        prevData.taxes +
        prevData.formation +
        prevData.achatElectricite +
        prevData.carnetFacture +
        prevData.salaires +
        prevData.indemnites +
        prevData.depannageRxInst +
        prevData.depensesAlimentation +
        prevData.depensesNettoiements +
        prevData.divers,
    }));
  }, [
    formData.achatGazoil,
    formData.transport,
    formData.verification,
    formData.reparation,
    formData.materielsElectriques,
    formData.fraisTransfert,
    formData.taxes,
    formData.formation,
    formData.achatElectricite,
    formData.carnetFacture,
    formData.salaires,
    formData.indemnites,
    formData.depannageRxInst,
    formData.depensesAlimentation,
    formData.depensesNettoiements,
    formData.divers,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "observations" || name === "selectedDate") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value === "" ? "" : Number(value),
    }));
  };

  const handleSubmit = async (event) => {
  event.preventDefault();

  try {
    const response = await api.post(
      "/api/sortiecaisse",
      formData
    );

    console.log("Form submitted:", response.data);

    toast.success("Formulaire soumis avec succès.");

    setFormData(getInitialFormData());
  } catch (error) {
    console.error(
      "Erreur lors de la soumission du formulaire!",
      error
    );

    toast.error(
      "Erreur lors de la soumission du formulaire. Veuillez réessayer."
    );
  }
};

  return (
    <Container maxWidth="lg" sx={{ mt: -2, ml: 3 }}>
      <Header
        title="Ajouter une dépense"
        subtitle="Les valeurs 0 sont remplies par défaut"
        sx={{ mb: 5 }}
      />
      <Grid container spacing={2} sx={{ mt: 0 }} justifyContent="center">
        <Grid item xs={8}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {[
                "achatGazoil",
                "transport",
                "verification",
                "reparation",
                "materielsElectriques",
                "fraisTransfert",
                "taxes",
                "formation",
                "achatElectricite",
                "carnetFacture",
                "salaires",
                "indemnites",
                "depannageRxInst",
                "depensesAlimentation",
                "depensesNettoiements",
                "divers",
                "total",
              ].map((field) => (
                <Grid item xs={4} key={field}>
                  <TextField
                    label={field.replace(/([A-Z])/g, " $1").trim()}
                    type="number"
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    required
                    fullWidth
                    InputProps={field === "total" ? { readOnly: true } : {}}
                    disabled={field === "total"}
                  />
                </Grid>
              ))}

              <Grid item xs={4}>
                <TextField
                  label="Observations"
                  type="text"
                  name="observations"
                  value={formData.observations}
                  onChange={handleChange}
                  fullWidth
                  multiline
                  // rows={4}
                />
              </Grid>

              <Grid item xs={6}>
                <Button
                  type="submit"
                  variant="contained"
                  color={mode === "dark" ? "secondary" : "primary"}
                  size="large"
                  sx={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  Ajouter
                </Button>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Date"
                  type="date"
                  name="selectedDate"
                  value={formData.selectedDate}
                  onChange={handleChange}
                  required
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    "& input::-webkit-calendar-picker-indicator": {
                      color: "darkgoldenrod",
                      filter:
                        "invert(0.5) sepia(1) saturate(10) hue-rotate(5deg) brightness(1.1) contrast(1.2)",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SortieCaisse;


// import React, { useState, useEffect } from "react";
// import { Grid, TextField, Button, Container } from "@mui/material";
// import { useSelector } from "react-redux";
// import Header from "components/Header";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import api from "services/api";

// const getCurrentDate = () => {
//   const today = new Date();
//   return today.toISOString().split("T")[0];
// };

// const SortieCaisse = () => {
//   const mode = useSelector((state) => state.global.mode);

//   const [formData, setFormData] = useState({
//     selectedDate: getCurrentDate(),
//     achatGazoil: 0,
//     transport: 0,
//     verification: 0,
//     reparation: 0,
//     materielsElectriques: 0,
//     fraisTransfert: 0,
//     taxes: 0,
//     formation: 0,
//     achatElectricite: 0,
//     carnetFacture: 0,
//     salaires: 0,
//     indemnites: 0,
//     depannageRxInst: 0,
//     depensesAlimentation: 0,
//     depensesNettoiements: 0,
//     divers: 0,
//     total: 0,
//     observations: "Rien à signaler",
//   });

//   useEffect(() => {
//     setFormData((prevData) => ({
//       ...prevData,
//       total:
//         prevData.achatGazoil +
//         prevData.transport +
//         prevData.verification +
//         prevData.reparation +
//         prevData.materielsElectriques +
//         prevData.fraisTransfert +
//         prevData.taxes +
//         prevData.formation +
//         prevData.achatElectricite +
//         prevData.carnetFacture +
//         prevData.salaires +
//         prevData.indemnites +
//         prevData.depannageRxInst +
//         prevData.depensesAlimentation +
//         prevData.depensesNettoiements +
//         prevData.divers,
//     }));
//   }, [
//     formData.achatGazoil,
//     formData.transport,
//     formData.verification,
//     formData.reparation,
//     formData.materielsElectriques,
//     formData.fraisTransfert,
//     formData.taxes,
//     formData.formation,
//     formData.achatElectricite,
//     formData.carnetFacture,
//     formData.salaires,
//     formData.indemnites,
//     formData.depannageRxInst,
//     formData.depensesAlimentation,
//     formData.depensesNettoiements,
//     formData.divers,
//     formData.observations,
//   ]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
  
//     // For the "observations" field, treat it as a string
//     if (name === "observations") {
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: value,
//       }));
//     } else {
//       // For all other fields, handle as numbers
//       setFormData((prevData) => ({
//         ...prevData,
//         [name]: value === "" ? "" : Number(value),
//       }));
//     }
//   };  

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     try {
//       const response = await fetch("/api/sortiecaisse", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       if (!response.ok) {
//         throw new Error(`Erreur HTTP! statut: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Form submitted:", data);

//       toast.success("Formulaire soumis avec succès.");

//       setFormData({
//         selectedDate: getCurrentDate(),
//         achatGazoil: 0,
//         transport: 0,
//         verification: 0,
//         reparation: 0,
//         materielsElectriques: 0,
//         fraisTransfert: 0,
//         taxes: 0,
//         formation: 0,
//         achatElectricite: 0,
//         carnetFacture: 0,
//         salaires: 0,
//         indemnites: 0,
//         depannageRxInst: 0,
//         depensesAlimentation: 0,
//         depensesNettoiements: 0,
//         divers: 0,
//         total: 0,
//         observations: "Rien à signaler",
//       });
//     } catch (error) {
//       console.error("Erreur lors de la soumission du formulaire!", error);
//       toast.error(
//         "Erreur lors de la soumission du formulaire. Veuillez réessayer."
//       );
//     }
//   };

//   return (
//     <Container maxWidth="lg" sx={{ mt: -2, ml: 3 }}>
//       <Header
//         title="Ajouter une dépense"
//         subtitle="Les valeurs 0 sont remplies par défaut"
//         sx={{ mb: 5 }}
//       />
//       <Grid container spacing={2} sx={{ mt: 0 }} justifyContent="center">
//         <Grid item xs={8}>
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
             
//               {[
//                 "achatGazoil",
//                 "transport",
//                 "verification",
//                 "reparation",
//                 "materielsElectriques",
//                 "fraisTransfert",
//                 "taxes",
//                 "formation",
//                 "achatElectricite",
//                 "carnetFacture",
//                 "salaires",
//                 "indemnites",
//                 "depannageRxInst",
//                 "depensesAlimentation",
//                 "depensesNettoiements",
//                 "divers",
//                 "total",
//               ].map((field) => (
//                 <Grid item xs={4} key={field}>
//                   <TextField
//                     label={field.replace(/([A-Z])/g, " $1").trim()}
//                     type="number"
//                     name={field}
//                     value={formData[field]}
//                     onChange={handleChange}
//                     required
//                     fullWidth
//                     InputProps={field === "total" ? { readOnly: true } : {}}
//                     disabled={field === "total"}
//                   />
//                 </Grid>
//               ))}
//                {/* Observations Field */}
//               <Grid item xs={4}>
//                 <TextField
//                   label="Observations"
//                   type="text"
//                   name="observations"
//                   value={formData.observations}
//                   onChange={handleChange}
//                   fullWidth
//                   multiline
//                   // rows={4}
//                 />
//               </Grid>
//               <Grid item xs={6}>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   color={mode === "dark" ? "secondary" : "primary"}
//                   size="large"
//                   sx={{
//                     width: "100%",
//                     height: "100%",
//                   }}
//                 >
//                   Ajouter
//                 </Button>
//               </Grid>
//               <Grid item xs={6}>
//                 <TextField
//                   label="Date"
//                   type="date"
//                   name="selectedDate"
//                   value={formData.selectedDate}
//                   onChange={handleChange}
//                   required
//                   fullWidth
//                   InputLabelProps={{
//                     shrink: true,
//                   }}
//                   sx={{
//                     "& input::-webkit-calendar-picker-indicator": {
//                       color: "darkgoldenrod", 
//                       filter: "invert(0.5) sepia(1) saturate(10) hue-rotate(5deg) brightness(1.1) contrast(1.2)", 
//                     }
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </form>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default SortieCaisse;
